import {useCallback, useMemo, useState} from 'react';
import type {ActualChangesWithSchema} from 'services/metadata/types';
import {
  metadataEditCloseChangeRequest,
  useActualChangesWithSchema,
} from 'services/metadata';
import {useAppStore} from 'store/hooks';
import type {ChangeRequestCardProps} from '../types';
import {getManifestationHeaderTitle} from '../functions';

export const useChangeRequestEditState = ({
  changeRequestId,
  initialManifestationId: _,
}: ChangeRequestCardProps): {
  title: string;
  initialExpanded: boolean;
  changeRequest: ActualChangesWithSchema | undefined;
  rejectRemaining: () => void;
  autoClose: () => void;
  removed: boolean;
} => {
  const {dispatch} = useAppStore();
  const [removed, setRemoved] = useState(false);
  const changeRequest = useActualChangesWithSchema(changeRequestId);
  const initialExpanded =
    changeRequest?.taskType === 'METADATA_MOVED' ||
    changeRequest?.taskType === 'METADATA_COPIED';

  const rejectRemaining = useCallback(() => {
    setRemoved(true);
    dispatch(metadataEditCloseChangeRequest({changeRequestId}));
  }, [changeRequestId, dispatch]);

  const autoClose = useCallback(() => {
    rejectRemaining();
  }, [rejectRemaining]);

  return useMemo(
    () => ({
      initialExpanded,
      title: getManifestationHeaderTitle(changeRequest?.original),
      changeRequest,
      rejectRemaining,
      autoClose,
      removed: changeRequest?.status === 'COMPLETED' && removed,
    }),
    [initialExpanded, changeRequest, rejectRemaining, autoClose, removed],
  );
};
